export const Help = (props: { message: string; align: 'left' | 'right' }) => {
  return (
    <div className={`help ${props.align}`}>
      <div className="help__icon"></div>
      <div className="help__content">{props.message}</div>
    </div>
  );
};
